import script from "./CircleIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./CircleIcon.vue?vue&type=script&setup=true&lang=js"

import "./CircleIcon.vue?vue&type=style&index=0&id=c2785800&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2785800"]])

export default __exports__